import { Component, OnInit, TemplateRef } from '@angular/core';
import { Dtd } from './dtd';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { DtdService } from './dtd.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-dtd',
  templateUrl: './dtd.component.html',
  styleUrls: ['./dtd.component.css']
})
export class DtdComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'DTD';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  dtdForm: FormGroup;
  dtds: Dtd[] = [];
  dtdsactive: Dtd[] = [];
  dtd: Dtd;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  dtdModalRef: BsModalRef;
  operation: string;
  userid: number;
  dtdid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'dtd'; //set default
  reverse: boolean = false;

  constructor(
    private dtdservice: DtdService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('DTD_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('DTD_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('DTD_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('DTD_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.dtdForm = this.formBuilder.group({
      dtdid: [''],
      dtd: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }
   
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.dtds = [];
    this.dtdsactive = [];
    this.dtdservice.Get().subscribe(res => {
      this.dtds = res;
      if (this.showallstatus == true) {
        this.dtds.forEach(data => {
          if (data.active == 1) {
            this.dtdsactive.push(data);
          }
        });
        this.dtds = [];
        this.dtds = this.dtdsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.dtdsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.dtds.forEach(data => {
        if (data.active == 1) {
          this.dtdsactive.push(data);
        }
      });
      this.dtds = [];
      this.dtds = this.dtdsactive;
    }
    else {
      this.showall = true;
      this.dtds = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizeddtd");
    let data = arrays.find(ob => ob['name'] === 'DTD');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizeddtd","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizeddtd",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.dtdModalRef.hide();
  }

  get g() { return this.dtdForm.controls; }

  Post(dtd: Dtd) {
    
    this.submitted = true;
    // stop here if form is invalid
    //if (this.dtdForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.dtdForm.errors);
    //}

    if ((dtd.dtd.trim() == undefined) || (dtd.dtd.trim() == '')) {
      this.toastr.error('DTD should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");

    dtd.dtd = dtd.dtd.trim();
    if (this.operation == 'add') {

      dtd.createdby = this.userid;
      msg = "Record Added Successfully";
      this.dtdservice.Post(dtd).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.dtdModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      dtd.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.dtdservice.Put(dtd).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.dtdModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.dtdForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.dtdForm.value.active = 1;
    } else {
      this.dtdForm.value.active = 0
    }
  }

  OpenConfirmTemplate(dtd, template: TemplateRef<any>) {
    if (dtd.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.dtd = dtd;

          this.Delete();

        }
       
      });

  }
  
  Delete() {
    var msg;
    if (this.dtd.active == 0) {
      this.dtd.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.dtd.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    
    this.dtd.modifiedby = this.userid;
    this.dtdservice.Delete(this.dtd).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }
   
  hidePopup() {
    this.dtdModalRef.hide();
  }

  openDtdModal(template: TemplateRef<any>, type, dtd?: Dtd) {
    this.operation = type
    
    if (type == 'update') {
      this.dtdForm.controls['dtdid'].setValue(dtd.dtdid);
      this.dtdForm.controls['dtd'].setValue(dtd.dtd);
      this.dtdForm.controls['active'].setValue(dtd.active);
      this.dtd = dtd;
    }
    if (type == 'add') {
      this.dtdForm.controls['dtdid'].setValue(0);
      this.dtdForm.controls['dtd'].setValue('');
      this.dtdForm.controls['active'].setValue(1);
    }
    this.dtdModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }
   
}
